import reloadCalendarSurfaceIfRequired from '../utils/reloadCalendarSurfaceIfRequired';
import { closeReadingPaneSurfaceMutator } from '../mutators/isReadingPaneVisibleMutators';
import { onCloseReadingPane } from 'mini-calendar-readingpane-store/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';

/**
 * Listens to reading pane close action and reloads calendar surface if required
 */
const closeReadingPaneSurfaceOrchestator = orchestrator(onCloseReadingPane, () => {
    closeReadingPaneSurfaceMutator();
    reloadCalendarSurfaceIfRequired();
});

export default closeReadingPaneSurfaceOrchestator;
